const Comment = (props) => props && props

export default Comment
